import { Box } from "@mui/material";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import MentionInputRender from "@common/components/mentionInput/MentionInputRender";

// Flattens rich text into the single line a table cell is tall. Exported for DynamicCellValueRenderer's plain-text
// cells, which need the same single line without the tooltip.
export const multiLineTextStyles = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "250px",
    maxWidth: "250px",
    minWidth: "250px",
    paddingRight: "16px",
    height: "1.2em",
    lineHeight: "1.2em",
    "& *": {
        whiteSpace: "nowrap !important",
        display: "inline !important",
    },
    // A heading keeps its own font size once inlined and would overflow the single line the cell is tall.
    "& :is(h1, h2, h3, h4, h5, h6)": { fontSize: "inherit !important" },
    // A table's cells are inlined like everything else, but their borders would still draw, turning one row
    // into a strip of boxed letters.
    "& :is(table, td, th)": { border: "none !important", padding: "0 !important" },
    // Inlining the blocks above removes the line break, so one paragraph's text would otherwise
    // be glued onto the next ("...(2026-09-14)Dette...").
    "& :is(p, li, h1, h2, h3, h4, blockquote, td, th) + *::before": { content: '"\\00a0"' },
};

export interface TruncatedMentionTextProps {
    value: string | undefined | null;
}

function TruncatedMentionText({ value }: TruncatedMentionTextProps) {
    if (!value) {
        return null;
    }

    return (
        // The tooltip paints a dark background, so its copy is told it sits on one - that is what
        // switches table borders and header fills to the white tones. The cell itself is on a white row.
        <DotLegalTooltip text={<MentionInputRender value={value} linkColor={"white"} />}>
            <Box sx={{ ...multiLineTextStyles, height: "1.5em" }}>
                <MentionInputRender value={value} linkColor={"primary"} />
            </Box>
        </DotLegalTooltip>
    );
}

export default TruncatedMentionText;
